export const DEAL_TEMPLATE_TYPE_NEW_DEAL_TEMPLATE: string = 'new-deal-template';
export const DEAL_TEMPLATE_TYPE_DUE_DILIGENCE_TEMPLATE: string = 'due-diligence-template';
